function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { useContext } from 'react';
import fetch from 'isomorphic-unfetch';
import Cookies from 'js-cookie';
import { REFRESH_ROUTE, ACCESS_TOKEN_COOKIE_NAME } from '@immediate_media/auth-utils';
import { createFabricApi } from '@immediate_media/fabric-api-clients';
import { SiteContext } from '@immediate_media/pocket-config';
import logger from './logger';
/**
 * A hook to get a configured fabric API client.
 *
 * The API client is configured with the relevant authentication functions,
 * see the fabric-api-clients package for details.
 *
 * https://github.immediate.co.uk/WCP-Packages/fabric-api-clients
 *
 * @example
 * const fabricApi = useFabricApi();
 *
 * fabricApi.collections.savedItems.get(42) // => Saved item 42
 */

var useFabricApi = function useFabricApi() {
  var _useContext = useContext(SiteContext),
      env = _useContext.env,
      siteKey = _useContext.siteKey,
      apiBaseURLs = _useContext.apiBaseURLs;

  var refreshDebug = function refreshDebug(msg) {
    return logger.debug("Failed to refresh access token: ".concat(msg));
  };

  return createFabricApi({
    env: env,
    siteKey: siteKey,
    baseURLs: apiBaseURLs,
    getToken: function getToken() {
      return Cookies.get(ACCESS_TOKEN_COOKIE_NAME);
    },
    refreshToken: function () {
      var _refreshToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _ref, href, res;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref = typeof window === 'undefined' ? REFRESH_ROUTE // fetch requires absolute paths in the browser
                : new URL(REFRESH_ROUTE, window.location), href = _ref.href;
                _context.next = 3;
                return fetch(href);

              case 3:
                res = _context.sent;

                if (!(res.status !== 200)) {
                  _context.next = 7;
                  break;
                }

                refreshDebug(res.status);
                return _context.abrupt("return", null);

              case 7:
                _context.prev = 7;
                _context.next = 10;
                return res.json();

              case 10:
                return _context.abrupt("return", _context.sent);

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](7);
                refreshDebug(_context.t0.message);

              case 16:
                return _context.abrupt("return", null);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[7, 13]]);
      }));

      function refreshToken() {
        return _refreshToken.apply(this, arguments);
      }

      return refreshToken;
    }()
  });
};

export default useFabricApi;